import { useState } from 'react';

interface RollingTipsProps {
  tips: string[];
}

export default function RollingTips({ tips }: RollingTipsProps) {
  const [open, setOpen] = useState(false);

  if (!tips || tips.length === 0) return null;

  return (
    <div className="bg-cannabis-800/50 rounded-xl border border-cannabis-700/50 overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-cannabis-800/80 transition"
      >
        <span className="text-cream font-semibold text-sm flex items-center gap-2">
          <span>How to Improve</span>
        </span>
        <span
          className={`text-cream/40 text-xs transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
        >
          ▼
        </span>
      </button>
      {open && (
        <div className="px-5 pb-4 space-y-3">
          {tips.map((tip, i) => (
            <div
              key={i}
              className="flex gap-3 items-start bg-cannabis-800 rounded-lg px-4 py-3"
            >
              <span className="text-cannabis-400 font-bold text-sm mt-0.5 shrink-0">
                {i + 1}.
              </span>
              <p className="text-cream/80 text-sm leading-relaxed">{tip}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
